import { render, staticRenderFns } from "./AuditEventTable.vue?vue&type=template&id=ecff5fc6&"
import script from "./AuditEventTable.vue?vue&type=script&lang=js&"
export * from "./AuditEventTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports